import SearchRequest from './SearchRequest';

class Filters {

	constructor(config) {
		this.stickyOffsetHeight = 100;
		if ($('[package="cms-product"] [data-scope="filters"]').length < 1) {
			return;
		}
		this.config = Object.assign({
			filters: '[data-scope="filters"]',
			products: '[data-scope="products"]',
			paginator: '[data-scope="paginator"]',
			sort: '[data-scope="sort"]:visible',
			limit: '[data-scope="limit"]:visible',
			search: '[data-scope="search"]:visible',
		}, config);

		this.initEventListeners();
	}

	initEventListeners() {
		$(this.config.filters).off('.product')
			.on('click.product', '[data-filter]', this.handleFilterClick.bind(this))
			.on('click.product', '.filters-reset', this.resetFilter.bind(this))

			.on('change.product', 'input[name="max_price"]', this.handleInputKeyValue.bind(this))
			.on('change.product', 'input[name="min_price"]', this.handleInputKeyValue.bind(this))
		;

		$(this.config.paginator).off('.product')
			.on('click.product', 'a.page-link', this.handlePage.bind(this));
		$(this.config.sort).off('.product')
			.on('change.product', 'select', this.handleSort.bind(this));
		$(this.config.limit).off('.product')
			.on('change.product', 'select', this.handleLimit.bind(this));
		$(this.config.search).off('.product')
			.on('click.product', 'button', this.handleSearch.bind(this))
			.on('keyup.product', 'input[name="q"]', this.handleSearchByKey.bind(this));

	}
	handleResponse(response) {
		$(this.config.filters).html( response.filters );
		$(this.config.products).html( response.products );
		$(this.config.paginator).html( response.paginator );
		$(this.config.paginator).html( response.paginator );
		this.initEventListeners();
	}

	async reload() {
		
		SearchRequest.setModule('product');
		SearchRequest.handleResponse = this.handleResponse.bind(this);
		await this.beforeCallback();
		await SearchRequest.doRequest();
		await this.afterCallback();
	}
	beforeCallback() {}
	afterCallback() {}

	resetScroll() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $('[package="cms-product"]').offset().top - this.stickyOffsetHeight
		}, 250);
	}


	resetFilter(e) {
		SearchRequest.clearByKey('filter', {});
		SearchRequest.clearByKey('min_price', {});
		SearchRequest.clearByKey('max_price', {});
		SearchRequest.clearByKey('page')
		this.reload();
		return false;
	}
	handlePage(e) {
		let $target = jQuery(e.currentTarget);
		SearchRequest.setPage($target.data('page'));
		this.reload();
        this.resetScroll();
        return false;
	}
	handleSearchByKey(e) {
		if (e.key === 'Enter' || e.keyCode === 13) {
			this.handleSearch(e);
		}
	}
	handleSearch(e) {
		let $input = jQuery(e.delegateTarget).find('[name="q"]');
		SearchRequest.setByKeyValue('q', $input.val());
		this.reload();
		return false;
	}

	handleInputKeyValue(e) {
		let $input= jQuery(e.target);
		let key = $input.attr('name');
		SearchRequest.setByKeyValue(key, $input.val());
		this.reload();
		return false;
	}

	handleLimit(e) {
		let limit = 24;
		if ($(e.target).is('select')) {
			SearchRequest.setLimit( $(e.target).val() );
			SearchRequest.setPage(1);
		} else {
			console.error('Dit is nog niet afgehandeld')
		}
		this.reload(); return false;
	}
	handleSort(e) {
		let $target = jQuery(e.currentTarget);
		let sort = $target.is('select') ?  $target.val() : $target.find('select').val();
		SearchRequest.setSort(sort);
		this.reload(); return false;
	}
	handleFilterClick(e) {
		let filterData = jQuery(e.currentTarget).data('filter');
		if (SearchRequest.hasFilter(filterData.tree_id, filterData.id)) {
			SearchRequest.clearFilter(filterData.tree_id, filterData.id);
			jQuery(e.currentTarget).find('input[type="checkbox"]').removeAttr('checked');
		} else {
			SearchRequest.addFilter(filterData.tree_id, filterData.id, filterData.title_seo)
			jQuery(e.currentTarget).find('input[type="checkbox"]').attr('checked', 'checked');
			SearchRequest.setPage(1);
		}
		this.reload()
		return false;
	}

};

export default Filters;